import { useQuery } from 'react-query';
import { getAllEventDescriptions } from 'services/event-descriptions-service';
import { ReactQueryKeys } from 'common/enums';
import { ApiResponse } from 'common/interfaces';
import { RequestStatuses } from '../../../constants';
import {
  VehicleOffersEventDescription,
  VehicleOffersEventDescriptionsResponse
} from './use-vehicle-offers-event-descriptions.types';

const modifyResponse = ({ data }: ApiResponse<VehicleOffersEventDescriptionsResponse[]>) => {
  if (data.level === RequestStatuses.Success) {
    return data.data.map(eventDescriptionsResponse => ({
      ...eventDescriptionsResponse.attributes,
      webroles: eventDescriptionsResponse.attributes.webroles.map(webrole => webrole.attributes)
    }));
  }
  return [];
};

const useVehicleOffersEventDescriptions = () => {
  const { data: vehicleOffersEventDescriptions } = useQuery<
    ApiResponse<VehicleOffersEventDescriptionsResponse[]>,
    unknown,
    VehicleOffersEventDescription[]
  >([ReactQueryKeys.GetVehicleOffersEventDescriptions], () => getAllEventDescriptions(), {
    select: modifyResponse
  });

  return { vehicleOffersEventDescriptions };
};

export default useVehicleOffersEventDescriptions;
